var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEducation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256,
    fill: "#ffc048",
    opacity: 1,
    "data-original": "#ffd300",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc048",
    d: "M512 256c0-6.092-.228-12.13-.646-18.116L474.4 200.93H37.6l52.552 52.552v112.809L63.76 399.88l91.543 91.542C186.211 504.661 220.247 512 256 512c141.385 0 256-114.615 256-256z",
    opacity: 1,
    "data-original": "#ff9e00",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#544f56",
    d: "M136.24 236.38v133.5H256l10-56.023-10-77.477z",
    opacity: 1,
    "data-original": "#544f56",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#403b41",
    d: "M256 236.38h119.76v133.5H256z",
    opacity: 1,
    "data-original": "#403b41",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M79.315 193.18h20.64v169.5h-20.64z",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0081ff",
    d: "m115.51 399.88-25.875-15.105L63.76 399.88v-25.875c0-14.29 11.585-25.875 25.875-25.875s25.875 11.585 25.875 25.875z",
    opacity: 1,
    "data-original": "#0081ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9f9fa5",
    d: "M37.6 200.93 256 289.74l10-79.689-10-97.931z",
    opacity: 1,
    "data-original": "#9f9fa5",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7c8186",
    d: "M256 112.12v177.62l218.4-88.81z",
    opacity: 1,
    "data-original": "#7c8186",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/education.7e933e915fc19e994e79ce7a874bbfb6.svg";
export { ForwardRef as ReactComponent };